import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";

const CooldownTimer = ({ endTimeUtc, message }) => {
  const textColorDynamic = useSelector((state) => state.setMode).css?.textColor;
  const [timeLeft, setTimeLeft] = useState(null);

  // Calculate the remaining time every second
  useEffect(() => {
    const targetTime = new Date(endTimeUtc).getTime();

    const updateCooldown = () => {
      const now = new Date().getTime();
      const timeDiff = targetTime - now;

      if (timeDiff > 0) {
        const minutes = Math.floor((timeDiff % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((timeDiff % (1000 * 60)) / 1000);
        setTimeLeft(`${minutes}m ${seconds}s`);
      } else {
        setTimeLeft(null);
      }
    };

    // Run updateCooldown every second
    const intervalId = setInterval(updateCooldown, 1000);

    // Clean up the interval on component unmount
    return () => clearInterval(intervalId);
  }, [endTimeUtc]);

  return (
    <div className={`${textColorDynamic} text-sm`}>
      {timeLeft ? (
        <div>
          <p>{message}</p>
          <p className="font-bold">Cooldown: {timeLeft}</p>
        </div>
      ) : (
        <p>Cooldown complete!</p>
      )}
    </div>
  );
};

export default CooldownTimer;
